import React, { useState } from 'react';
import { LANGUAGES } from '../utils/translation';
import './TranslationSetupDialog.css';

/**
 * Dialog for setting up auto-translation on a column
 */
export default function TranslationSetupDialog({
  isOpen,
  onClose,
  onApply,
  currentConfig,
  numCols,
  currentColIdx
}) {
  const [sourceColumn, setSourceColumn] = useState(
    currentConfig?.sourceColumn ?? (currentColIdx > 0 ? currentColIdx - 1 : 0)
  );
  const [sourceLang, setSourceLang] = useState(currentConfig?.sourceLang ?? 'NL');
  const [targetLang, setTargetLang] = useState(currentConfig?.targetLang ?? 'EN');

  if (!isOpen) return null;

  const handleApply = () => {
    onApply({
      sourceColumn: parseInt(sourceColumn),
      sourceLang,
      targetLang
    });
    onClose();
  };

  const handleRemove = () => {
    onApply(null); // null means remove translation config
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content translation-dialog" onClick={(e) => e.stopPropagation()}>
        <h3>🌐 Setup Auto-Translation</h3>
        <p style={{ fontSize: '0.9rem', color: 'var(--text-secondary)', marginBottom: '1rem' }}>
          This column will automatically translate text from another column.
        </p>

        <div className="form-group">
          <label>Source Column:</label>
          <select
            value={sourceColumn}
            onChange={(e) => setSourceColumn(e.target.value)}
            className="form-select"
          >
            {Array.from({ length: numCols }, (_, i) => (
              <option key={i} value={i} disabled={i === currentColIdx}>
                Column {i + 1} {i === currentColIdx ? '(this column)' : ''}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Source Language:</label>
          <select
            value={sourceLang}
            onChange={(e) => setSourceLang(e.target.value)}
            className="form-select"
          >
            {LANGUAGES.map(lang => (
              <option key={lang.code} value={lang.code}>
                {lang.name} ({lang.code})
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Target Language:</label>
          <select
            value={targetLang}
            onChange={(e) => setTargetLang(e.target.value)}
            className="form-select"
          >
            {LANGUAGES.map(lang => (
              <option key={lang.code} value={lang.code}>
                {lang.name} ({lang.code})
              </option>
            ))}
          </select>
        </div>

        <div className="dialog-buttons">
          <button onClick={onClose} className="btn-secondary">
            Cancel
          </button>
          {currentConfig && (
            <button onClick={handleRemove} className="btn-danger">
              Remove Translation
            </button>
          )}
          <button onClick={handleApply} className="btn-primary">
            Apply
          </button>
        </div>
      </div>
    </div>
  );
}
